import React from "react";

import { LogoBox, MenuContainer, SideNavBarWrapper } from "./sideNavBar.styled";
import { ROUTE_NAMES } from "../../constants/routeNames";

import CustomNavLink from "./components/customNavLink";

import logoImage from "../../assets/images/logo_prod_1.png";

import homeIcon from "../../assets/svgIcons/home-icon.svg";
import active_homeIcon from "../../assets/svgIcons/home-icon-active.svg";

import candidateIcon from "../../assets/svgIcons/candidate-icon.svg";
import active_candidateIcon from "../../assets/svgIcons/candidate-icon-active.svg";

import cardsetIcon from "../../assets/svgIcons/cardset-icon.svg";
import active_cardsetIcon from "../../assets/svgIcons/cardset-icon-active.svg";

import reportIcon from "../../assets/svgIcons/report-icon.svg";
import active_reportIcon from "../../assets/svgIcons/report-icon-active.svg";

import deleteIcon from "../../assets/svgIcons/delete-icon.svg";
import active_deleteIcon from "../../assets/svgIcons/delete-icon-active.svg"

import helpIcon from "../../assets/svgIcons/help-icon.svg";
import active_helpIcon from "../../assets/svgIcons/help-icon-active.svg";

const menuListGroupOne = [
  {
    label: "Dashboard",
    icon: homeIcon,
    activeIcon: active_homeIcon,
    route: ROUTE_NAMES.Dashboard,
    role: "all",
    show: true,
    disable: false,
  },
  {
    label: "Clients",
    icon: candidateIcon,
    activeIcon: active_candidateIcon,
    route: ROUTE_NAMES.Clients,
    role: "all",
    show: true,
    disable: false,
  },
  {
    label: "Payments",
    icon: helpIcon,
    activeIcon: active_helpIcon,
    route: ROUTE_NAMES.Payments,
    role: "all",
    show: true,
    disable: false,
  },
  {
    label: "Activation",
    icon: reportIcon,
    activeIcon: active_reportIcon,
    route: ROUTE_NAMES.Activation,
    role: "all",
    show: true,
    disable: false,
  },
  {
    label: "CEPs",
    icon: helpIcon,
    activeIcon: active_helpIcon,
    route: ROUTE_NAMES.CEP,
    role: "all",
    show: true,
    disable: false,
  },
  {
    label: "Delete User",
    icon: deleteIcon,
    activeIcon: active_deleteIcon,
    route: ROUTE_NAMES.DeleteUser,
    role: "all",
    show: true,
    disable: false,
  },
  {
    label: "CEP View",
    icon: helpIcon,
    activeIcon: active_helpIcon,
    route: ROUTE_NAMES.CEP_Dashboard,
    role: "admin",
    show: true,
    disable: false,
  },
];
const SideNavBar = () => {
  const isAdmin = true;
  const roleID = localStorage.getItem("@role");
  const roleid = 102 === Number(roleID);
  const padminroleid = 101 === Number(roleID);
  return (
    <SideNavBarWrapper className="">
      <LogoBox className="">
        <div className="logo_img_box ">
          <img src={logoImage} />
        </div>
      </LogoBox>
      <p>&nbsp;</p>
      <MenuContainer>
        {menuListGroupOne?.map((opt, idx) => {
          const clickable = !opt?.disable;
          if (roleid && opt.role === "admin")
            return <CustomNavLink opt={opt} key={idx} clickable={clickable} />;
          if (opt.role === "all" && !padminroleid && !roleid)
            return <CustomNavLink opt={opt} key={idx} clickable={!clickable} />;
          if (opt.role === "all" && !roleid)
            return <CustomNavLink opt={opt} key={idx} clickable={clickable} />;
          return null;
        })}
      </MenuContainer>
    </SideNavBarWrapper>
  );
};

export default SideNavBar;
